import React from "react";
import * as styles from "./styles_vanilla.css";

interface DataTypeChipProps {
  /** The data type to display (e.g., "Accounts", "Contacts", "Notes") */
  dataType: string;
}

export const DataTypeChip: React.FC<DataTypeChipProps> = ({ dataType }) => {
  return (
    <div className={styles.chip}>
      <span className={styles.chipText}>{dataType}</span>
    </div>
  );
};

export default DataTypeChip;
